module.exports = __webpack_public_path__ + "static/img/11.638606f6.png";